const doc = [({"en":({"js":({"admin":({"photo_colors":({"create_card":({"create_photo_color":"Create photo color"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;